<div class="ticket" [class]="status">
  <div class="d-flex justify-content-between">
    <span class="ticket-flight_number">LA{{ ticket.flightNumber }}</span>
    <div class="d-flex gap-1">
      <div>
        <img src="assets/images/airplane_boarding.svg" alt="Avião Partindo"/>
      </div>
      <span class="ticket-boarding_date">{{ ticket.departureDateLt | dateFormat: 'DD/MM/YYYY HH:mm' }}</span>
    </div>
  </div>
  
  @if (isActive) {
    <div class="d-flex justify-content-end">
      <app-seat-availability [items]="[ticket]"></app-seat-availability>
    </div>
  }

  <div class="d-flex justify-content-between">
    <span class="ticket-origin_destiny">{{ ticket.departure }} / {{ ticket.arrival }}</span>
    <div class="d-flex gap-1">
      <div>
        <img src="assets/images/airplane_arrival.svg" alt="Avião Chegando"/>
      </div>
      <span class="ticket-arrival_date">{{ ticket.arrivalDateLt | dateFormat: 'DD/MM/YYYY HH:mm' }}</span>
    </div>
  </div>

  <div class="d-flex justify-content-between">
    <div class="d-flex gap-1">
      <span class="ticket_number">{{ ticket.ticketNumber }}</span>
      <div class="copy-text" (click)="copyText(ticket.ticketNumber)" #tooltip="matTooltip" matTooltip="Copiar">
        <img src="assets/images/copy.svg" alt="Copiar Texto">
      </div>
    </div>

    @if (isActive) {
      <div class="d-flex gap-1">
        <a class="web-checking" href="https://www.latamairlines.com/br/pt/check-in"
          target="_blank" rel="noopener noreferrer">
          WEB CHECKING
        </a>
      </div>
    }
  </div>

  <div class="d-flex justify-content-between">
    <div class="d-flex gap-1">
      <span class="ticket-reservation_code">{{ ticket.pnrCode }}</span>
      <div class="copy-text" (click)="copyText(ticket.pnrCode);" #tooltip="matTooltip" matTooltip="Copiar">
        <img src="assets/images/copy.svg" alt="Copiar Texto">
      </div>
    </div>
    @if (isActive) {
      <button class="btn-cancel" (click)="cancelTicket()" >Cancelar</button>
    }
  </div>
</div>
